import React, { Component } from 'react';
import './css/About.css';
import border1 from './images/about_border.jpg';
const Link = require("react-router-dom").Link;

class Links extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="aboutContainer-real">
                <div className="column">
                    <div className="textContainer-about">
                    <h2>Art related links:</h2><br />
                    <div className="center">
                        <ul>
                        <li>
                                    <a href="https://fineartamerica.com/art/bryan+whitehead" target="new">
                                        Prints available at FineArtAmerica
                                    </a>
                                </li>
                                <li>
                                    <Link to="/Backgrounds">
                                        Digital backgrounds - seamless or large
                                    </Link>
                                </li>
                                
                                <li>
                                    <a href="https://filterforge.com/filters/author14083-page1.html" target="new">
                                        Some of my filterforge work
                                    </a>
                                </li>
                                
                            </ul>
                    </div>
                        
                    <h2>Other fun stuff Bryan created:</h2><br />
                    <div className="center">
                        <ul>
                            <li>
                                Games
                                <ul>
                                    <li>
                                        <a href="/dungeon" target="new">
                                            The Forgotten Descent <span className="link-description">(Rogue-like)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/starbreaker" target="new">
                                            Star Breaker 2173 <span className="link-description">(Asteroid spoof)</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Utils
                                <ul>
                                    {/*
                                    <li>
                                        <a href="http://www.whiteheadgallery.com/temp/calc_py.html" target="new">
                                            P&G Practice Assessment calculator</a>
                                    </li>
                                    */}
                                    <li>
                                        <a href="http://www.whiteheadgallery.com/temp/baseConvertor.html" target="new">
                                            Base number convertor <span className="link-description">(useless tool)</span></a>
                                        
                                    </li>
                                    <li>
                                        <a href="/wordcloud" target="_blank" rel="noreferrer">
                                            Wordcloud app <span className="link-description">(word visualization)</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Media
                                <ul>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/noCroak.mp4" target="new">
                                            Toad lost his croak! <span className="link-description">(Animated Music Video)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/AI_writeTheCode.mp4" target="new">
                                            AI Write the Code <span className="link-description">(Animated Song - AI going at it!)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/isAvailable.mp4" target="new">
                                            Is it Still Available <span className="link-description">(Animated Song - facebook marketplace)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/fartv.mp4" target="new">
                                            Fart on Plants <span className="link-description">(Animated Song)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/lunaTail.mp3" target="new">
                                            Luna Lizard <span className="link-description">(Song)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/noTokens.mp3" target="new">
                                            Out of Tokens <span className="link-description">(Song)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/otherTeamJogs.mp3" target="new">
                                            Bengals - Other Team Jogs and Scores <span className="link-description">(Song)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/ateDirt.mp3" target="new">
                                            Accidentally Ate Dirt <span className="link-description">(Song)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/Capybara.mp3" target="new">
                                            Friendly Capybara <span className="link-description">(Song)</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.whiteheadgallery.com/temp/tardigradeSong.mp3" target="new">
                                            Tardigrade Song <span className="link-description">(Song)</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    


                    <br /><br /><br /><br />
                    </div>
                </div>
                <div><img src={border1} className="aboutFooter" alt="Footer - boats]" /></div>
            </div>
        );
    }
}
 
export default Links;
